<div data-target="serviceNotAvailable" cdkTrapFocus>
  <article class="dt-l-article">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>

      <section class="dt-l-article__section">
        <h1 class="dt-l-article__section__title" tabindex="-1">
          {{ 'SYSTEM_NOT_AVAILABLE_HEADER' | translate }}
        </h1>
        <p
          class="dt-l-article__section__description"
          [innerHTML]="this.errorMessage || ('SERVICE_NOT_AVAILABLE_TEXT1' | translate)"></p>
        <p class="dt-l-article__section__description" [innerHTML]="'SERVICE_NOT_AVAILABLE_TEXT2' | translate"></p>
        <p class="dt-l-article__section__description">{{ 'SERVICE_NOT_AVAILABLE_TEXT3' | translate }}</p>
        <div class="dt-l-button-group">
          <button
            type="button"
            class="dt-c-button primary orderButtonVertical"
            (click)="getConfigAndNavigateToCockpit()"
            >{{ 'BACK_TO_HOMESCREEN' | translate }}</button
          >
        </div>
      </section>
    </div>
  </article>
</div>
